import DummyBridge from "./DummyBridge";

let b = new DummyBridge();

let isBridgeAvailable = false;

export function initBridge() {
  try {
    // @ts-ignore
    b = new Bridge();
    isBridgeAvailable = true;
  } catch (e) {
    console.log("Bridge not available");
    b = new DummyBridge();
    isBridgeAvailable = false;
  }

  return isBridgeAvailable;
}

function getB(): DummyBridge {
  if (!isBridgeAvailable) {
    // retry
    initBridge();
  }
  return b;
}

export default getB;
